module.exports = __webpack_public_path__ + "media/images/ana_sobre-70332231ea971d3741a586418a164d6e.png";